import * as TY from 'containers/pages/addressManagement/constants';
import { AddressValidation } from 'containers/pages/addressManagement/types';

type SetValidFn = (fn: (prev: AddressValidation) => AddressValidation) => void;

function handleAddress(
  e: { target: { name: string; value: string } },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatch: (action: { type: string; payload: any }) => void,
  setValid: SetValidFn,
) {
  const name = e.target.name.trim();
  const value = e.target.value;

  switch (name) {
    case TY.TITLE:
      dispatch({ type: TY.TITLE, payload: value });
      setValid((prev) => ({
        ...prev,
        Title: {
          isErr: !value.trim(),
          errMsg: !value.trim() ? 'Title is required' : '',
          canNotSave: !value.trim(),
        },
      }));
      break;

    case TY.LINE1:
      dispatch({ type: TY.LINE1, payload: value });
      setValid((prev) => ({
        ...prev,
        Line1: {
          isErr: !value.trim(),
          errMsg: !value.trim() ? 'Address Line 1 is required' : '',
          canNotSave: !value.trim(),
        },
      }));
      break;

    case TY.LINE2:
      dispatch({ type: TY.LINE2, payload: value });
      break;

    case TY.CITY:
      dispatch({ type: TY.CITY, payload: value });
      setValid((prev) => ({
        ...prev,
        City: {
          isErr: !value.trim(),
          errMsg: !value.trim() ? 'City is required' : '',
          canNotSave: !value.trim(),
        },
      }));
      break;

    case TY.PROVINCE:
      dispatch({ type: TY.PROVINCE, payload: value });
      setValid((prev) => {
        const trimmed = value.trim();
        const invalid = !trimmed || trimmed.length !== 2;
        return {
          ...prev,
          Province: {
            isErr: invalid,
            errMsg: !trimmed ? 'Province is required' : trimmed.length !== 2 ? 'Province must be exactly 2 characters (e.g. AB)' : '',
            canNotSave: invalid,
          },
        };
      });
      break;

    case TY.POSTAL_CODE:
      dispatch({ type: TY.POSTAL_CODE, payload: value });
      setValid((prev) => ({
        ...prev,
        PostalCode: {
          isErr: !value.trim(),
          errMsg: !value.trim() ? 'Postal code is required' : '',
          canNotSave: !value.trim(),
        },
      }));
      break;

    case TY.COUNTRY:
      dispatch({ type: TY.COUNTRY, payload: value });
      setValid((prev) => ({
        ...prev,
        Country: {
          isErr: !value.trim(),
          errMsg: !value.trim() ? 'Country is required' : '',
          canNotSave: !value.trim(),
        },
      }));
      break;

    case TY.PATROL_TYPE:
      dispatch({ type: TY.PATROL_TYPE, payload: value });
      setValid((prev) => ({
        ...prev,
        PatrolType: {
          isErr: !value,
          errMsg: !value ? 'Patrol type is required' : '',
          canNotSave: !value,
        },
      }));
      break;

    case TY.INSTRUCTIONS:
      dispatch({ type: TY.INSTRUCTIONS, payload: value });
      break;

    case TY.ONLINE_MAP_URL:
      dispatch({ type: TY.ONLINE_MAP_URL, payload: value });
      break;

    default:
      dispatch({ type: name, payload: value });
      break;
  }
}

export default handleAddress;
